import "core-js/modules/es.array.push.js";
import { $h, Tips, basePost, U, baseGet, URL, SplitArray, urlParams } from '@/utils/util.js';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import loading from '@/components/loading/loading.vue';
import zrcheader from '@/components/zrcheader/index.vue';
import zrcfooter from '@/components/zrcfooter/index.vue';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
export default {
  name: 'IndexView',
  data() {
    return {
      xzmenu: 1,
      cailiaoceshi_list: [],
      monijisuan_list: [],
      cate_jiance_id: 1,
      cate_moni_id: 1,
      xzfwid: 0,
      hlsactive: 1,
      ppactive: 1,
      xznewcid: 1,
      newsone_list: [],
      news_list: [],
      zrctoken: '',
      loadingStatus: true
    };
  },
  components: {
    loading,
    zrcheader,
    Swiper,
    SwiperSlide
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y]
    };
  },
  created() {
    var that = this;
    this.getParams();
    setTimeout(() => {
      this.loadingStatus = false;
    }, 2000);
  },
  onLoad(option) {
    console.log('参数');
  },
  watch: {},
  methods: {
    getParams() {
      var that = this;
      // 取到路由带过来的参数
      //console.log(that.$route.query);
      const option = this.$route.query;
      that.id = option.id || 1;
    },
    //提交保存任务
    lijidenglu: function () {
      var that = this;
      var url = U({
        m: 'andrapi',
        c: 'andrpublic_api',
        a: 'dengluyanz_new',
        q: {
          curzdf: that.$data.curzdf,
          sjtel: that.$data.dltel,
          sfcard: that.$data.dlsfz,
          dlpass: that.$data.dlmima,
          yanzma: that.$data.yanzma
        }
      }, URL);
      baseGet(url, function (res) {
        Tips('登录成功', 'success');
        store.commit('SetZrctoken', res.data.zrctoken);
        router.push({
          path: '/home'
        });
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    handleMouseEnter(id) {
      console.log('鼠标进入了元素');
      var that = this;
      that.xzfwid = id;
      // 可以在这里添加逻辑，比如改变元素的样式或状态  
    },
    handleMouseLeave() {
      console.log('鼠标离开了元素');
      var that = this;
      that.xzfwid = 0;
      // 可以在这里添加逻辑，比如恢复元素的样式或状态  
    },
    //切换材料测试
    SelectCateSonId: function (id) {
      var that = this;
      that.cate_jiance_id = id;
    },
    //切换模拟测试
    SelectCateMoniId: function (id) {
      var that = this;
      that.cate_moni_id = id;
    },
    //去新闻中心
    gozixun: function (id) {
      var that = this;
      that.cate_moni_id = id;
    },
    //切换新闻分类
    selecetnewcid: function (id) {
      var that = this;
      that.xznewcid = id;
      that.get_news_list();
    },
    //获取执行文章栏目的文章
    get_news_list: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'get_news_list',
        q: {
          cid: that.$data.xznewcid
        }
      }, URL);
      baseGet(url, function (res) {
        that.newsone_list = res.data.info.newsone_list;
        that.news_list = res.data.info.news_list;
      });
    },
    //获取首页的数据
    get_index: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'index'
      }, URL);
      baseGet(url, function (res) {
        that.cailiaoceshi_list = res.data.info.cailiaoceshi_list;
        that.monijisuan_list = res.data.info.monijisuan_list;
        that.newsone_list = res.data.info.newsone_list;
        that.news_list = res.data.info.news_list;
      });
    },
    //进入到具体的新闻内容
    goxinwen: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/newsdetail',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    },
    //进入到具体的项目内容
    goprojectdetail: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/projectdetail',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    }
  },
  mounted: function () {
    var that = this;
    that.get_index(); //首页的信息
  }
};